import {Typography, useMediaQuery} from "@mui/material";
import {WithChildren} from "../../types/WithChildren";
import * as React from "react";

export default function PageHeader({children}: WithChildren) {
  // @ts-ignore
  const align = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Typography variant="h3" mb={2} fontSize={align ? 32 : 48}>{children}</Typography>
  )
}